module.exports = [() => ({
  require: 'ngModel',
  scope: {
    otherModelValue: '=compareWith',
    notEqual: '=compareNotEqual',
  },
  link($scope, $element, $attributes, ngModel) {
    ngModel.$validators.compareFields = (modelValue) => {
      if ($scope.notEqual) {
        return modelValue !== $scope.otherModelValue;
      }
      return modelValue === $scope.otherModelValue;
    };

    $scope.$watch('otherModelValue', () => {
      ngModel.$validate();
    });
  },
})];



// WEBPACK FOOTER //
// ./main/directives/compare-fields.js